import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Users from './pages/Users';
import Carousel from './pages/Carousel';
import Currency from './pages/Currency';
import ProductEdit from './pages/ProductEdit';
import ProductNew from './pages/ProductNew';
import PaymentInfo from './pages/PaymentInfo';
import Messages from './pages/Messages';
import FAQs from './pages/FAQs';
import Blogs from './pages/Blogs';
import Analytics from './pages/Analytics';
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public login route */}
        <Route path="/admin/login" element={<Login />} />
        
        {/* Protected admin routes */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="products/new" element={<ProductNew />} />
          <Route path="products/:id/edit" element={<ProductEdit />} />
          <Route path="orders" element={<Orders />} />
          <Route path="users" element={<Users />} />
          <Route path="carousel" element={<Carousel />} />
          <Route path="currency" element={<Currency />} />
          <Route path="payment-info" element={<PaymentInfo />} />
          <Route path="messages" element={<Messages />} />
          <Route path="faqs" element={<FAQs />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="analytics" element={<Analytics />} />
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
        </Route>
        
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </div>
  );
}

export default App;
